import PostCreatePage from './post-create-page';
import PostCreateModalLoader from './post-create-modal-loader';
import forDevice from '../../hoc/for-device';

const PostEditorPageOrModal = forDevice(PostCreateModalLoader, PostCreatePage);

export default PostEditorPageOrModal;
